import type { PermissionData } from '../types'

export function computeSwapPermission(permissionData: PermissionData) {
  if (permissionData.routesCount !== 2) return 'hidden'

  return 'enabled'
}
